import React from 'react';
import { MTabControl } from '../MTabControl/index';
import { MTabControlAlignment } from '../MTabControl/MTabControl.types';
import { MSlot } from '../MSlot/index';
import * as Styled from './MTabItem.styles';
import { type MTabItemProps } from './MTabItem.types';

const COMPONENT_NAME = 'm-web-ui-kit-MTabItem';
const TEST_ID = 'web-ui-kit-MTabItem';

function MTabItem({
  id,
  label,
  description,
  showIcon = false,
  aIcon = {},
  alignment = MTabControlAlignment.Left,
  active = false,
  onTabClick,
  mSlot = {},
  children,
  className,
  ...rest
}: MTabItemProps) {
  const tabId = id ? `${id}-tab` : undefined;
  const panelId = id ? `${id}-panel` : undefined;
  const hasCqItems = mSlot.cqItems && Object.keys(mSlot.cqItems).length > 0;
  const shouldRenderSlot = hasCqItems || mSlot.isAuthorMode;

  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} className={className} {...rest}>
      <MTabControl
        id={tabId}
        label={label}
        description={description}
        showIcon={showIcon}
        aIcon={aIcon}
        alignment={alignment}
        active={active}
        onClick={onTabClick}
        aria-controls={panelId}
      />
      <Styled.ContentArea $hidden={!active} role="tabpanel" id={panelId} aria-labelledby={tabId} aria-hidden={!active}>
        {shouldRenderSlot ? (
          <MSlot
            pagePath={mSlot.pagePath ?? ''}
            itemPath={mSlot.itemPath ?? ''}
            isAuthorMode={mSlot.isAuthorMode}
            cqItems={mSlot.cqItems}
            allowedComponents={mSlot.allowedComponents}
            className={mSlot.className}
            containerClassName={mSlot.containerClassName}
            model={mSlot.model}
          />
        ) : (
          children
        )}
      </Styled.ContentArea>
    </Styled.Wrapper>
  );
}

export { MTabItem, TEST_ID as M_TAB_ITEM_TEST_ID };
